import Typography from '@mui/material/Typography';
import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext.tsx';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { FlatList } from '@openx/components-core/lib/TransferList/FlatList.tsx';
import {
  FormTypes,
  type InventoryListByIdAPI,
  InventoryListFormFields,
  type ListData,
} from '@openx/types/inventoryList.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { listTypesLabels } from '../constants.tsx';

type InventoryListDetailsProps = {
  inventoryList: InventoryListByIdAPI;
};

export const InventoryListDetails = ({ inventoryList }: InventoryListDetailsProps) => {
  const { t } = useTranslation();
  const { useAccountOptionsFetch } = useAdministrationContext();
  const { accounts } = useAccountOptionsFetch();
  const listTypeLabels = listTypesLabels();

  const mappedListData: ListData[] = useMemo(
    () => inventoryList[InventoryListFormFields.VALUES].map(item => ({ id: item, name: item, isOnList: true })),
    [inventoryList]
  );

  const organization = accounts.mapById[inventoryList.account_uid]?.name ?? inventoryList.account_uid;
  const listType = inventoryList.type_full === 'inventorylist.domain' ? FormTypes.DOMAINS : FormTypes.BUNDLES;

  return (
    <>
      <FormSection data-test="organization-section" title={t('Organization')} divider>
        <FieldDetails value={organization} title={t('Organization')} />
      </FormSection>

      <FormSection title={t('Details')} divider>
        <FieldDetails value={inventoryList.name} title={t('Name')} />
        <FieldDetails value={inventoryList.description} title={t('Description')} />
      </FormSection>

      <FormSection title={t('Inventory')}>
        <FieldDetails value={listTypeLabels[listType]} title={t('List Type')} />
        <Typography variant="body1Bold" sx={{ mt: 1, mb: 2 }}>
          {t('{type} [ {count} ]', {
            type: listTypeLabels[listType],
            count: inventoryList.values.length,
          })}
        </Typography>

        <FlatList
          handleRowClick={() => {
            return undefined;
          }}
          dataTest="transfer-list-bulk-list"
          data={mappedListData}
          isDisabled={true}
          isSelectedList={false}
          hasBulkInput={false}
          hideActionIcon
        />
      </FormSection>
    </>
  );
};
